module.exports = __webpack_public_path__ + "static/media/the-vanquished.52ad9b74.jpg";